import { ENUM_TYPE_DOWNLOAD } from 'constants/enum';
import {
  SET_HISTORY_CREATE_SURVEY,
  SET_STEP_CREATE_SURVEY,
  CLEAR_CREATE_SURVEY,
  SET_OPEN_DOWNLOAD,
  SET_OPEN_CREATE_OPTIONS,
  SET_OPEN_SCHEDULE,
  SET_OPEN_CANCEL_SCHEDULE,
} from 'store/types/survey';

const initialState = {
  history_create_survey: [],
  step_create_survey: 0,
  openCreateOptions: {
    isOpen: false,
  },
  openDownload: {
    isOpen: false,
    type: ENUM_TYPE_DOWNLOAD.CSV,
  },
  openSchedule: {
    isOpen: false,
    data: null,
    callBack: null,
  },
  openCancelSchedule: {
    isOpen: false,
    id: null,
    callBack: null,
  },
};

const surveyReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_HISTORY_CREATE_SURVEY:
      return {
        ...state,
        history_create_survey: [...(action?.payload || [])],
      };
    case SET_STEP_CREATE_SURVEY:
      return {
        ...state,
        step_create_survey: action?.payload,
      };
    case SET_OPEN_DOWNLOAD:
      return {
        ...state,
        openDownload: action?.payload,
      };
    case SET_OPEN_CREATE_OPTIONS:
      return {
        ...state,
        openCreateOptions: action?.payload,
      };
    case CLEAR_CREATE_SURVEY:
      return {
        ...state,
        ...initialState,
      };
    case SET_OPEN_SCHEDULE:
      return {
        ...state,
        openSchedule: action?.payload,
      };
    case SET_OPEN_CANCEL_SCHEDULE:
      return {
        ...state,
        openCancelSchedule: action?.payload,
      };
    default:
      return state;
  }
};

export default surveyReducer;
